import { apiClient } from "./client";

const GetAllBedsByRoomId = (roomId) => {
  return apiClient
    .get("/BedReservation/GetAllBedsByRoomId", {
      params: {
        'roomId': roomId
      }
    });
}
const Add = (data) => {
  return apiClient.post('/BedReservation', {
    "bedId": data.bedId,
    "from": data.from,
    "to": data.to,
    "passengerId": data.passengerId
  }
  )
}

const UpdateReserveEvent = (id, isReserve) => {
  return apiClient.put('/BedReservation/UpdateReserveEvent', null, {
    params: {
      'Id': id,
      'IsReserve': isReserve
    }
  }
  )
}

const UpdateBedReservationDate = (data) => {
  return apiClient.put('/BedReservation/UpdateBedReservationDate', {
    "from": data.from,
    "to": data.to
  }, {
    params: {
      'Id': data.id
    }
  }
  )
}

const bedReservationApi = {
  GetAllBedsByRoomId, Add, UpdateReserveEvent, UpdateBedReservationDate
}

export default bedReservationApi